import { Component, Input, OnInit } from "@angular/core";
import {
  ControlContainer,
  FormArray,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { EButtonType } from "../../data-types/button.enum";
import { IService } from "../../data-types/services.interface";
import { EStorageType } from "../../data-types/storage.enum";
import { CoworkingService } from "../../services/coworking.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { ServicesService } from "../../services/services.service";
import { showAlertAction } from "../../store/actions/alert.action";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { IAppState } from "../../store/state/app.state";

@Component({
  selector: "cowing-core-coworking-services",
  templateUrl: "./coworking-services.component.html",
  styleUrls: ["./coworking-services.component.scss"],
})
export class CoworkingServicesComponent implements OnInit {
  @Input("form") form: FormArray;

  public essentials: Array<IService> = [];
  public covid: Array<IService> = [];
  public others: Array<IService> = [];
  public EButtonType = EButtonType;
  constructor(
    private translate: TranslateService,
    private coworkingService: CoworkingService,
    private servicesService: ServicesService,
    private _store: Store<IAppState>,
    private _translate: TranslateService,
    private router: Router
  ) {
    FormControl.prototype["setRawValue"] = function (
      this: FormControl,
      custom: any
    ): void {
      this["rawValue"] = custom;
    };
    FormGroup.prototype["setGroupName"] = function (
      this: FormGroup,
      title: any
    ): void {
      this["groupName"] = title;
    };
  }

  async ngOnInit() {
    this._store.dispatch(showLoadingAction({}));

    try {
      const coworkingId = LocalStorageService.instance.get(
        EStorageType.ActiveCoworking
      );
      let coworkingServices = [];
      if (coworkingId && this.isEditingInfo) {
        const response = await this.coworkingService.getCoworkingServices(
          coworkingId
        );
        coworkingServices = response;
      }
      const response = await this.servicesService.getServices();
      let group = response.reduce((r, a) => {
        r[a.type] = [...(r[a.type] || []), a];
        return r;
      }, {});

      for (const key in group) {
        let newForm = new FormGroup({});
        group[key].forEach((form, i) => {
          if (i === 0) {
            newForm["setGroupName"](form.type);
          }

          if (coworkingServices.length) {
            const coincidence = coworkingServices.find((service) => {
              return service.label === form.label;
            });
            if (coincidence) {
              let control = new FormControl(true);
              control["setRawValue"](form);
              newForm.addControl(form.label, control);
            } else {
              let control = new FormControl(form.value);
              control["setRawValue"](form);
              newForm.addControl(form.label, control);
            }
          } else {
            let control = new FormControl(form.value);
            control["setRawValue"](form);
            newForm.addControl(form.label, control);
          }
        });

        this.form.push(newForm);
      }
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message:
              e.status === 401
                ? this.translate.instant("general.expired")
                : this._translate.instant("coworking.services.error"),
            title: this._translate.instant("coworking.services.caution"),
            type: "error",
          },
        })
      );
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }
  public getFormGroup(typeName) {
    for (let control of this.form.controls) {
      if (control instanceof FormGroup) {
        // is a FormGroup
        if (control["groupName"] && control["groupName"] === typeName) {
          return control;
        }
      }
    }
  }

  private formatServices() {
    let selectedServices: Array<any> = [];
    let servicesFormArray: any = this.form;
    servicesFormArray.controls.forEach((serviceGroup) => {
      for (const service in serviceGroup.controls) {
        let anyService: any = serviceGroup.controls[service];
        selectedServices.push({
          id: anyService.rawValue.id,
          value: anyService.value || false,
        });
      }
    });
    return selectedServices;
  }
  public async putSpaces() {
    const coworkingId = LocalStorageService.instance.get(
      EStorageType.ActiveCoworking
    );
    this._store.dispatch(showLoadingAction({}));
    try {
      await this.coworkingService.putServices(
        this.formatServices(),
        coworkingId
      );
      this._store.dispatch(
        showAlertAction({
          payload: {
            message: "",
            title: this.translate.instant("coworking.services.success_put"),
            type: "alert",
          },
        })
      );
      this.goBack();
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message: this._translate.instant("coworking.services.error"),
            title: this._translate.instant("coworking.services.success_put"),
            type: "error",
          },
        })
      );
    } finally {
      this._store.dispatch(closeLoadingAction({}));
      this.goBack();
    }
  }
  public get isEditingInfo() {
    return this.router.url === "/coworking-services" ? true : false;
  }
  public goBack() {
    this.router.navigate(["coworking-home"]);
  }
  public get isDisabledForm() {
    // console.log(this.form);
    return this.form.valid ? false : true;
  }
}
